const emptyLoad = {
  total_weight: undefined,
  item_height: undefined,
  item_width: 80,
  item_length: 120,
  load_type: 'PALLET',
  pallet_type: 'EU_PALLET',
  number_of_items: 1,
  temperature_range: null,
};

const mockFirstLoad = {
  total_weight: 2000,
  item_height: 160,
  item_width: 80,
  item_length: 120,
  load_type: 'PALLET',
  pallet_type: 'EU_PALLET',
  number_of_items: 10,
};

const mockSecondLoad = {
  total_weight: 5000,
  item_height: 160,
  item_width: 100,
  item_length: 120,
  load_type: 'PALLET',
  pallet_type: 'US_PALLET',
  number_of_items: 5,
};

const initialState = {
  FIRST: {
    ...emptyLoad,
    loadKey: 'FIRST',
  },
  FIRST_LOAD_RECURRING: {
    ...emptyLoad,
    loadKey: 'FIRST_LOAD_RECURRING',
  },
};

const initialStateForTest = {
  FIRST: {
    ...mockFirstLoad,
    loadKey: 'FIRST',
  },
  SECOND: {
    ...mockSecondLoad,
    loadKey: 'SECOND',
  },
};
export default initialState;
export { initialStateForTest, emptyLoad, mockFirstLoad };
